import Constants from "expo-constants";

/**
 * Where the API lives, from the device's point of view.
 *
 * Separate from `api.ts` because this imports `expo-constants`, which pulls in
 * React Native's Flow-typed entry point. Anything importing that becomes
 * unparseable by the test runner, so the API client stays free of it and is
 * told the answer instead.
 *
 * `localhost` is the DEVICE, not the laptop, so a phone on the same network
 * needs the machine's LAN address. Expo already knows it -- `hostUri` is how
 * the device found the dev server -- so it is reused rather than asking
 * somebody to hardcode an IP they will forget to change.
 */
export function resolveApiBaseUrl(): string {
  const explicit = process.env["EXPO_PUBLIC_API_URL"];
  if (explicit) return explicit.replace(/\/$/, "");

  const hostUri = Constants.expoConfig?.hostUri;
  if (hostUri) return `http://${hostUri.split(":")[0]}:8787`;

  return "http://127.0.0.1:8787";
}
